<template>
	<div
		class="torir-spectrogram-marker"
	>
		<div
			v-if="marker.usePoint"
			class="--point"
		/>
		<div
			v-if="marker.text !== null"
			class="--text"
		>
			{{ marker.text }}
		</div>
	</div>
</template>

<script>
import Marker from '../lib/Marker'

/**
 * @vue-prop {Marker} marker マーカー
 */
export default {
	name: 'MarkerView',
	props: {
		marker: {
			type: Marker,
			required: true
		}
	}
}
</script>

<style lang="scss">
.torir-spectrogram-marker {
	position: absolute;
	width: 0;
	height: 0;
	margin: 0;
	padding: 0;
	overflow: visible;

	.--point {
		position: absolute;
		left: 0;
		top: 0;
	}

	.--text {
		position: absolute;
		left: 0;
		top: 0;
		width: auto;
		height: auto;
		white-space: nowrap;
		color: #fff;
	}
}
</style>
